const mapSiderStrings = {
    languageLabel: {
        "pl-PL": "Język",
        "uk-UA": "Язик"
    },
    selectedLanguage: {
        "pl-PL": "wybrano",
        "uk-UA": "вибрано"
    },
    map: {
        "pl-PL": "Mapa Pikniku",
        "uk-UA": "Карта пікніка"
    },
    stands: {
        "pl-PL": "Lista stref i stanowisk",
        "uk-UA": "Перелік зон і стендів"
    },
    backToWebsite: {
        "pl-PL": "Powrót do pikniknaukowy.pl",
        "uk-UA": "Повернутися на pikniknaukowy.pl"
    },
    myList: {
        "pl-PL": "Ścieżki zwiedzania",
        "uk-UA": "Мій маршрут"
    },
    mapSettings: {
        "pl-PL": "Dostępność",
        "uk-UA": "Налаштування карти"
    },
    highContrast:{
        "pl-PL": "Wysoki kontrast",
        "uk-UA": "Високий контраст"
    },
    navigationSettings: {
        "pl-PL": "Ustawienia nawigacji",
        "uk-UA": "Налаштування навігації"
    },
    facilities:{
        "pl-PL": "Trasa dla osób z niepełnosprawnościami",
        "uk-UA": "Маршрут"
    },
    cancel:{
        "pl-PL": "Anuluj",
        "uk-UA": "Скасувати"
    }
};

export default mapSiderStrings
